import { BD_SEARCH_ACCOUNT, BD_SEARCH_PORTFOLIO } from 'IntegrationsApp/ts/constants';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class BlackDiamondIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    deactivateBlackDiamondIntegration() {
        const url = this.urlsService.INTEGRATIONS.BLACK_DIAMOND_INTEGRATION_OAUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getBlackDiamondIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.BLACK_DIAMOND_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    getBlackDiamondAccountSearchResults(searchTerms, page) {
        const urlParams = { searchType: BD_SEARCH_ACCOUNT };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.BLACK_DIAMOND_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getBlackDiamondPortfolioSearchResults(searchTerms, page) {
        const urlParams = { searchType: BD_SEARCH_PORTFOLIO };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.BLACK_DIAMOND_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getBlackDiamondPortfolioAccounts(portfolioKey, page) {
        const urlParams = { portfolioKey };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.BLACK_DIAMOND_PORTFOLIO_ACCOUNTS, urlParams)}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importBlackDiamondAccountHoldings(postParams) {
        const url = this.urlsService.INTEGRATIONS.BLACK_DIAMOND_IMPORT_ACCOUNT_HOLDINGS;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
BlackDiamondIntegrationService.ɵfac = function BlackDiamondIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BlackDiamondIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
BlackDiamondIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BlackDiamondIntegrationService, factory: BlackDiamondIntegrationService.ɵfac, providedIn: 'root' });
